export default __webpack_public_path__ + "locales/uk-UA/DeleteThirdPartyDialog.json?hash=60554a6fb4744ea69e3ea99b6750b62e";